import { useMemo, useState } from "react";
import { styled } from "styled-components";
import { StaticMetricItem } from "./StaticMetricItem";
import { AnalyticsContainerIntro } from "../../Pages/DashboardStyle";
import {
    excludedKeys,
    keysToModify,
    modifiedKeys,
} from "../../DataConstants/StaticMetricsConstants";
import { useAppSelector } from "../../Hooks/Hooks";
import { selectStaticData } from "../../Redux/Data/DataSlice";

const StaticMetrics = styled.div`
    width: 80%;
    height: 25%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    animation: ${AnalyticsContainerIntro}
        ${(props) => props.theme.animationTime.medium}s;
    box-shadow: 0px 0px 13px 7px rgba(0, 0, 0, 0.74);
    border: 1px solid #ffa600;
    @media screen and (max-width: ${(props) => props.theme.breakpoint}px) {
        height: 100%;
        width: 100%;
        padding-top: 70%;
        flex-direction: column;
        justify-content: center;
        align-items: space-around;
        box-shadow: none;
        border: none;
    }
`;

export const StaticMetricsContainer: React.FC = () => {
    const [entries, setEntries] = useState<{ text: string; value: number }[]>(
        []
    );
    const staticData = useAppSelector(selectStaticData);

    useMemo(() => {
        if (staticData) {
            setEntries(
                Object.keys(staticData)
                    .filter((key) => !excludedKeys.includes(key))
                    .map((key) => {
                        return {
                            text: key,
                            value: staticData[key],
                        };
                    })
                    .sort(
                        (entryOne, entryTwo) => entryTwo.value - entryOne.value
                    )
            );
        }
    }, [staticData]);

    return (
        <StaticMetrics>
            {entries.map((entry, idx) => {
                const text = keysToModify.includes(entry.text)
                    ? modifiedKeys.filter(
                          (modifiedKeysEntry) =>
                              modifiedKeysEntry.originalKey === entry.text
                      )[0].newKey
                    : entry.text;
                return (
                    <StaticMetricItem
                        text={text}
                        value={entry.value}
                        key={idx}
                    />
                );
            })}
        </StaticMetrics>
    );
};
